// Utilitaires pour l'administration

// Valeurs prédéfinies par défaut (en cas d'erreur de chargement)
export const defaultPredefinedValues = {
  ramOptions: ['4 Go', '8 Go', '16 Go', '32 Go', '64 Go', '128 Go'],
  cpuOptions: ['2 cores', '4 cores', '8 cores', '16 cores', '32 cores', '64 cores'],
  diskOptions: ['250 Go SSD', '500 Go SSD', '1 To SSD', '2 To SSD', '500 Go NVMe', '1 To NVMe', '2 To NVMe'],
  osOptions: [
    'Ubuntu 20.04 LTS',
    'Ubuntu 22.04 LTS',
    'Debian 11',
    'Debian 12',
    'CentOS 7',
    'Rocky Linux 8',
    'Rocky Linux 9',
    'Windows Server 2019',
    'Windows Server 2022'
  ],
  mariadbVersionOptions: ['10.8.8', '10.9.8', '10.10.5', '10.11.2', '10.11.4'],
  apacheVersionOptions: ['2.4.52', '2.4.55', '2.4.56', '2.4.58', 'N/A'],
  nodejsVersionOptions: ['14.20.1', '16.18.0', '18.15.0', '18.16.0', '20.5.0']
};

/**
 * Sauvegarde les valeurs prédéfinies via l'API
 * @param {Object} values - Les valeurs à sauvegarder
 * @returns {Promise<Object>} - Résultat de la sauvegarde
 */
export const savePredefinedValues = async (values) => {
  try {
    console.log('Données envoyées à l\'API pour sauvegarde:', values);
    
    const response = await fetch('/api/admin/predefined-values', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    
    if (!response.ok) {
      throw new Error('Erreur lors de la sauvegarde des valeurs prédéfinies');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Erreur:', error);
    return null;
  }
};
